import { closeAllDropdowns } from '@/view/shared/Dropdown';
import { Drawer as HeroDrawer } from '@heroui/react';
import { useEffect } from 'react';
import type { ReactNode } from 'react';

interface DrawerProps {
  isOpen: boolean | null;
  setIsOpen: (isOpen: boolean | null) => void;
  title?: string;
  children: ReactNode;
  placement?: 'right' | 'left' | 'top' | 'bottom';
  className?: string;
}

export function Drawer({
  isOpen,
  setIsOpen,
  title,
  children,
  placement = 'right',
  className = '',
}: Readonly<DrawerProps>) {
  useEffect(() => {
    if (isOpen) closeAllDropdowns();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <HeroDrawer.Backdrop
      defaultOpen
      isDismissable
      onOpenChange={(open) => {
        if (!open) setIsOpen(null);
      }}
    >
      <HeroDrawer.Content placement={placement}>
        <HeroDrawer.Dialog className={className}>
          <HeroDrawer.Handle />
          <HeroDrawer.CloseTrigger />
          {title && (
            <HeroDrawer.Header>
              <HeroDrawer.Heading>{title}</HeroDrawer.Heading>
            </HeroDrawer.Header>
          )}
          <HeroDrawer.Body>{children}</HeroDrawer.Body>
        </HeroDrawer.Dialog>
      </HeroDrawer.Content>
    </HeroDrawer.Backdrop>
  );
}
